export default __webpack_public_path__ + "static/media/hostaway_step4.a191b61b.jpg";